<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-layout row class="ml-3">
      <v-flex xs12 lg8 md8>
        <h1 class="my-3">Действующие настройки</h1>

        <v-layout row>
          <v-flex xs12 lg12 md12>
            <v-layout class="elevation-1 white mb-4 pa-3">
              <v-flex xs6>
                <div class="mb-2">
                  <span class="title">Дата: </span>
                  <span class="title font-weight-thin">{{ appSettings.date !== null ? $moment(appSettings.date).format('D MMM YYYY') : '' }}</span>
                </div>
                <div class="mb-2">
                  <span class="title">Процент кешбека за заказы: </span>
                  <span class="title font-weight-thin">{{ appSettings.order_percent !== null ? appSettings.order_percent + '%' : '' }}</span>
                </div>
                <div class="mb-2">
                  <span class="title">Процент вычета кешбека за возвраты: </span>
                  <span class="title font-weight-thin">{{ appSettings.refund_percent !== null ? appSettings.refund_percent + '%' : '' }}</span>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <h1 class="my-3">Обновление настроек</h1>

        <v-layout row>
          <v-flex xs12 lg12 md12>
            <v-text-field
              label="Процент кешбека за заказы"
              v-model="appNewSettings.order_percent"
              outline
              suffix="%"
            ></v-text-field>
            <v-text-field
              label="Процент вычета кешбека за возвраты"
              v-model="appNewSettings.refund_percent"
              outline
              suffix="%"
            ></v-text-field>
            <p class="title">Дата обновления настроек</p>
            <v-date-picker
                v-model="appNewSettings.date"
                :reactive="true"
                locale="ru"
                class="mr-3 ml-0 mt-0 mb-3"
                :first-day-of-week="1"
                :min="$moment().format('YYYY-MM-DD')"
            ></v-date-picker>
          </v-flex>
        </v-layout>
        <v-layout row class="pa-0 ma-0">
          <v-flex xs12 lg6 md6>
            <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                @click.native="loader = 'loading'"
                class="ma-0"
                @click="onClickUpdateSettings"
            >
              Обновить
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    components: { draggable },
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Настройки'}
      ],
      pageDataReady: {
        isReady: true,
        appSettings: true
      },
      appSettings: {
        date: null,
        order_percent: null,
        refund_percent: null
      },
      appNewSettings: {
        date: null,
        order_percent: null,
        refund_percent: null
      }
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.appSettings) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onCreated () {
        this.appSettings = {
          date: null,
          order_percent: null,
          refund_percent: null
        }
        this.appNewSettings = {
          date: null,
          order_percent: null,
          refund_percent: null
        }

        this.$store.commit('setPageLoading', false)

        this.$store.dispatch('getAppSettings')
          .then(() => {
            this.pageDataReady.appSettings = true
            this.pageDataStatus()
          })
        this.$store.commit('setPageTitle', 'Настройки')
      },
      async onClickUpdateSettings () {
        this.$store.dispatch('updateAppSettings', this.appNewSettings)
        this.$store.dispatch('getAppSettings')
      }
    },
    computed: {
      getterAppSettings () {
        return this.$store.getters.appSettings
      },
      getterAppNewSettings () {
        return this.$store.getters.appNewSettings
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      getterAppSettings (val) {
        if (this.getterAppSettings !== null) {
          this.appSettings = this.getterAppSettings
        }
      },
      getterAppNewSettings (val) {
        if (this.getterAppNewSettings !== null) {
          this.appNewSettings = this.getterAppNewSettings
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Settings.vue